export interface MainTeamOption {
  name: string;
  website?: string;
}

export const MAIN_TEAM_OPTIONS: MainTeamOption[] = [
  { name: 'Sheffield Ice Tigers', website: 'https://www.sheffieldicetigers.co.uk' },
  { name: 'Peterborough Warriors', website: 'https://www.peterborough-warriors.com/' },
  { name: 'Peterborough Predators', website: 'https://peterboroughpredators.com/' },
  { name: 'Leeds Warriors', website: 'https://www.leedswarriors.com/' },
  { name: 'Nottingham Cyclones', website: 'https://nottinghamcyclones.square.site/' },
  { name: 'Blackburn Buccanners', website: 'https://buccaneersihc.co.uk/' },
  { name: 'Nottingham Knights', website: 'https://www.facebook.com/nottinghamknights/?locale=en_GB' },
  { name: 'Manchester Swarm', website: 'https://mcrswarm.co.uk/' },
  { name: 'Basingstoke Coyotes', website: '' },
  { name: 'Bristol Underdogs', website: 'https://www.instagram.com/bristolunderdogs_ihc/' },
  { name: 'None' },
];

export const OTHER_MAIN_TEAM = 'None';

export const getMainTeamWebsite = (
  mainTeam: string | undefined,
  customWebsite: string | undefined
): string | undefined => {
  if (!mainTeam) return undefined;
  if (mainTeam === OTHER_MAIN_TEAM) return customWebsite || undefined;

  const matching = MAIN_TEAM_OPTIONS.find((team) => team.name === mainTeam);
  return matching?.website;
};
